import * as React from 'react';
import Checkbox from '../Checkbox/Checkbox';
import { DateInput } from '../DateInput/DateInput';
import { Icon } from '../Icon/Icon';
import { FilterItem } from './Types';

export interface ISearchFilterProp {
    searchtext: string;
    datefrom: string;
    dateto: string;
    clearfilter: () => void;
    selectedfilters: number[];
    addfilter: (filterId) => void;
    removefilter: (filterId) => void;
    onupdate: (data) => void;
    region: string;
    className?: string | undefined;
}

interface ISearchFilterState {
    selectedfilters: number[];
    searchtext: string;
    datefrom: string;
    dateto: string;
    dropdownopen?: boolean;
}

export class SearchFilter extends React.Component<ISearchFilterProp, ISearchFilterState> {
    static GetFilterById(id: number): FilterItem {
        const filters = SearchFilter.filterItems;
        const index = filters.findIndex((x) => x.id === id);

        return SearchFilter.filterItems[index];
    }

    private static filterItems: FilterItem[] = [
        new FilterItem(0, 'Nyheter', ['NewsArticlePage']),
        new FilterItem(1, 'Områdessidor', ['LandingPage']),
        new FilterItem(2, 'Trafikkameror', ['CameraPage', 'CameraAreaPage']),
        new FilterItem(4, 'Trafikmeddelanden', ['SituationSearchModel']),
        new FilterItem(6, 'Trafikanordningsplaner', ['TAPlanSearchModel'], ['GBG']),
        new FilterItem(5, 'Övriga sidor', ['PagePage']),
    ];

    private defaultFilter = {
        selectedfilters: [],
        searchtext: '',
        datefrom: '',
        dateto: '',
    };

    constructor(props: ISearchFilterProp) {
        super(props);
        this.state = this.defaultFilter;
    }

    render(): JSX.Element {
        const filtersContent = SearchFilter.filterItems.map(this.renderfilterItem.bind(this));

        return (
            <div className={this.props.className}>
                <form className="search-info__filter" onSubmit={this.handleSubmit}>
                    <div className="d-flex search-info__standard-filter mb-md-4">
                        <div className="input-group search-info__search">
                            <div className="input-group-text">
                                <Icon symbol="icon-search" />
                            </div>
                            <input
                                className="form-control"
                                type="search"
                                placeholder="Fritextsökning"
                                name="searchtext"
                                value={this.props.searchtext}
                                onChange={this.handleUpdate}
                            />
                        </div>
                        <button
                            type="button"
                            className="btn btn-link text-nowrap search-info__filter-button collapsed d-md-none"
                            data-bs-toggle="collapse"
                            data-bs-target="#filter-choices"
                            aria-expanded="false"
                            aria-controls="filter-choices"
                        >
                            Fler filter
                            <i className="icon-animated icon-up-open" aria-hidden="true" />
                        </button>
                    </div>
                    <div id="filter-choices" className="collapse d-md-block mt-3 mt-md-0">
                        <div className="search-info__heading">Ändra urval</div>
                        <div className="search-info__filter-list">
                            <div>
                                <ul>{filtersContent}</ul>
                            </div>
                            <hr className="search-info__filter_divider" />
                            <div className="search-info__date">
                                <div className="search-info__heading search-info__date-heading">Datumintervall:</div>
                                <div className="search-info__date-range">
                                    <div className="search-info__date-field">
                                        <label htmlFor="datefrom">Från:</label>
                                        <DateInput
                                            className="form-control"
                                            id="datefrom"
                                            name="datefrom"
                                            value={this.props.datefrom}
                                            max={this.props.dateto}
                                            onChange={(date) => this.props.onupdate({ datefrom: date })}
                                        />
                                    </div>
                                    <div className="search-info__date-field">
                                        <label htmlFor="dateto">Till:</label>
                                        <DateInput
                                            className="form-control"
                                            id="dateto"
                                            name="dateto"
                                            value={this.props.dateto}
                                            min={this.props.datefrom}
                                            onChange={(date) => this.props.onupdate({ dateto: date })}
                                        />
                                    </div>
                                </div>
                                <div className="search-info__small-info">(Visar resultat som är aktiva vid valt datum)</div>
                            </div>
                            <hr className="search-info__filter_divider" />
                            <button type="button" className="btn btn-dark search-info__cancel" onClick={this.props.clearfilter}>
                                <i className="icon-cancel" aria-hidden="true" />
                                Återställ standardval
                            </button>
                        </div>
                    </div>
                </form>
            </div>
        );
    }

    private handleSubmit(e) {
        e.preventDefault();
    }

    private handleChangedFilter(event, filter) {
        const checked = event.target.checked;

        if (checked) {
            this.props.addfilter(filter.id);
        } else {
            this.props.removefilter(filter.id);
        }
    }

    private renderfilterItem(filter: FilterItem, index: number): JSX.Element {
        if (filter.hiddenregions.indexOf(this.props.region.toUpperCase()) !== -1) {
            return null;
        }

        const id = 'filter_item_' + index + '_' + filter.id;
        const isChecked =
            this.props.selectedfilters.filter((item: number) => {
                if (item === filter.id) {
                    return true;
                }

                return false;
            }).length > 0;
        const currentFilter = filter;
        const handleChange = (event) => {
            this.handleChangedFilter(event, currentFilter);
        };
        const itemClass = index > 0 ? 'mt-3' : '';

        return (
            <li key={`${index}${filter.id}_major`} className={itemClass}>
                <Checkbox name={id} label={filter.name} onChange={handleChange} checked={isChecked} />
            </li>
        );
    }

    private handleUpdate = (event) => {
        const data = {};
        data[event.target.name] = event.target.value;
        this.props.onupdate(data);
    };
}
